import styled from "styled-components";

import { LockDropdownItem } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

export const DropdownOptionText = styled(Text)`
    text-indent: 0;
`;

export const LockedDropdownItem = styled(LockDropdownItem)`
    display: flex;
`;
